import i18n from 'i18n/config';
import { useEffect, useState } from 'react';

import { SelectorOption } from 'types';

import { SingleValue } from 'react-select';
import { basicBoardStatus } from 'modules/boards/constants/basicBoardStatus';

type UseGetStatusOptionsProps = {
  status?: string;
};

export const useGetStatusOptions = ({ status }: UseGetStatusOptionsProps) => {
  const [statusOptions, setStatusOptions] = useState<SelectorOption[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [selectedStatusOption, setSelectedStatusOption] =
    useState<SelectorOption | null>(null);

  const handleChangeStatus = (option: SingleValue<SelectorOption>) => {
    if (option) {
      setSelectedStatus(option.value);
      setSelectedStatusOption(option);
    }
  };

  useEffect(() => {
    const statusOptions: SelectorOption[] = Object.values(basicBoardStatus).map(
      (status) => ({
        value: status.value,
        label: i18n.t(status.label),
      })
    );

    if (status) {
      const selectedOption = statusOptions.find(
        (option) => option.value === status
      );
      setSelectedStatus(status);
      setSelectedStatusOption(selectedOption || null);
    } else {
      const defaultOption = statusOptions.find(
        (option) => option.value === basicBoardStatus.PENDING.value
      );
      setSelectedStatus(basicBoardStatus.PENDING.value);
      setSelectedStatusOption(defaultOption || null);
    }

    setStatusOptions(statusOptions);
  }, [i18n.language]);

  return {
    data: {
      statusOptions,
      selectedStatus,
      selectedStatusOption,
    },
    actions: {
      handleChangeStatus,
    },
  };
};
